
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, Filter } from "lucide-react";

interface Category {
  id: string;
  name: string;
  color: string | null;
}

interface EpisodesSearchFilterProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedCategory: string | null;
  setSelectedCategory: (categoryId: string | null) => void;
  categories: Category[];
}

const EpisodesSearchFilter = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  categories,
}: EpisodesSearchFilterProps) => {
  return (
    <section className="w-full py-12 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
          <div className="relative flex-1 max-w-lg">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-6 w-6 text-gray-400" />
            <Input
              type="text"
              placeholder="Search episodes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-12 py-4 text-lg bg-white/80 border-sky-blue/30 focus:border-teedee-blue"
            />
          </div>
          
          <div className="flex gap-3 flex-wrap">
            <Button 
              variant={selectedCategory === null ? "default" : "outline"}
              onClick={() => setSelectedCategory(null)}
              className={selectedCategory === null ? 
                "bg-teedee-blue hover:bg-teedee-blue/90 text-white px-6 py-3" :
                "border-teedee-blue text-teedee-blue hover:bg-teedee-blue hover:text-white px-6 py-3"
              }
            >
              <Filter className="mr-2 h-5 w-5" />
              All Categories
            </Button>
            
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={selectedCategory === category.id ? "default" : "outline"}
                onClick={() => setSelectedCategory(selectedCategory === category.id ? null : category.id)}
                className={selectedCategory === category.id ?
                  "text-white px-6 py-3" :
                  "border-gray-300 text-gray-700 hover:bg-gray-50 px-6 py-3"
                }
                style={selectedCategory === category.id ? 
                  { backgroundColor: category.color || '#3B82F6' } : 
                  { borderColor: category.color || '#3B82F6', color: category.color || '#3B82F6' }
                }
              >
                {category.name}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EpisodesSearchFilter;
